import { render, staticRenderFns } from "./ClientOrder.vue?vue&type=template&id=2c39d321&scoped=true&"
import script from "./ClientOrder.vue?vue&type=script&lang=js&"
export * from "./ClientOrder.vue?vue&type=script&lang=js&"
import style0 from "./ClientOrder.vue?vue&type=style&index=0&id=2c39d321&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39d321",
  null
  
)

export default component.exports